{
  "title": "Bệnh nhân",
  "addTitle": "Thêm bệnh nhân mới",
  "editTitle": "Sửa bệnh nhân",
  "editTitleWithName": "Sửa bệnh nhân: {{name}}",
  "detailsTitle": "Chi tiết bệnh nhân",
  "detailsTitleWithName": "Chi tiết: {{name}}",
  "addPatient": "Thêm bệnh nhân",
  "updatePatient": "Cập nhật bệnh nhân",
  "actions": {
    "moreActions": "Thêm thao tác",
    "columns": "Tùy chỉnh cột",
    "export": "Xuất file",
    "import": "Nhập file",
    "addingPatient": "Đang thêm bệnh nhân...",
    "updatingPatient": "Đang cập nhật bệnh nhân..."
  },
  "identityRail": {
    "bookAppointment": "Đặt lịch",
    "bookAppointmentLink": "Đặt lịch hẹn",
    "recordPayment": "Thu tiền",
    "nextAppointment": "Lịch hẹn tiếp",
    "nextAppointmentDoctor": "BS {{name}}",
    "noAppointmentTitle": "Chưa có lịch hẹn",
    "noAppointmentHint": "Bệnh nhân chưa đặt lịch hẹn.",
    "outstanding": "Công nợ",
    "noDebtTitle": "Không còn nợ",
    "noDebtHint": "Bệnh nhân không còn công nợ điều trị.",
    "noRelationshipTitle": "Chưa có mối quan hệ",
    "noRelationshipHint": "Chưa liên kết bệnh nhân nào với hồ sơ này.",
    "ageYears": "{{age}} tuổi",
    "medicalHistory": "Tiền sử",
    "source": "Nguồn",
    "noSource": "Chưa ghi nhận",
    "otherInfo": "Thông tin khác",
    "viewMoreInfo": "Xem thêm thông tin",
    "goToAppointments": "Xem lịch hẹn",
    "goToPayments": "Xem thanh toán"
  },
  "dialogs": {
    "importTitle": "Nhập danh sách bệnh nhân"
  },
  "permissionDenied": "Bạn không có quyền xem danh sách bệnh nhân.",
  "searchPlaceholder": "Tìm theo tên, số điện thoại hoặc email",
  "searchPatients": "Tìm kiếm bệnh nhân...",
  "notFound": "Không tìm thấy bệnh nhân",
  "patientIdLabel": "Mã bệnh nhân: {{id}}",
  "registeredLabel": "Đăng ký: {{date}}",
  "noEmail": "Chưa có email",
  "saving": "Đang lưu...",
  "deleting": "Đang xóa...",
  "filter": "Lọc",
  "filterTitle": "Lọc bệnh nhân",
  "filters": "Bộ lọc",
  "clearAll": "Xóa tất cả",
  "applyFilters": "Áp dụng",
  "sort": "Sắp xếp",
  "moreOptions": "Tùy chọn khác",
  "notScheduled": "Chưa đặt lịch",
  "noMatch": "Không có bệnh nhân nào khớp với tìm kiếm hoặc bộ lọc.",
  "ariaActions": "thao tác",
  "importExport": {
    "chooseFile": "Chọn file CSV hoặc Excel",
    "dropHint": "Nhấn để chọn hoặc kéo thả file CSV hoặc Excel",
    "acceptHint": "CSV hoặc Excel (.xlsx), tối đa 20MB / 20000 dòng. Excel: chỉ đọc sheet đầu.",
    "invalidFile": "Vui lòng chọn file CSV hoặc Excel (.xlsx)",
    "changeFile": "Đổi file",
    "commit": "Nhập dữ liệu",
    "downloadTemplate": "Tải file mẫu",
    "downloadErrors": "Tải dòng lỗi (CSV)",
    "errorsCsvFilename": "benh-nhan-loi.csv",
    "noFile": "Vui lòng chọn file CSV hoặc Excel",
    "previewTitle": "Kết quả kiểm tra",
    "total": "Tổng dòng",
    "toCreate": "Sẽ tạo mới",
    "toUpdate": "Sẽ cập nhật",
    "errorsTitle": "Lỗi",
    "row": "Dòng",
    "code": "Mã",
    "message": "Chi tiết",
    "readyToCommit": "File hợp lệ. Bạn có thể nhập dữ liệu.",
    "hasErrors": "File còn lỗi. Sửa rồi kiểm tra lại trước khi nhập.",
    "resultTitle": "Kết quả nhập",
    "created": "Đã tạo",
    "updated": "Đã cập nhật",
    "uploading": "Đang tải file…",
    "checking": "Đang kiểm tra file…",
    "checkingWithCount": "Đang kiểm tra {{count}} dòng…",
    "importing": "Đang nhập dữ liệu…",
    "importingWithCount": "Đang nhập {{count}} dòng…",
    "confirmUpdateTitle": "Xác nhận cập nhật",
    "confirmUpdateMessage": "Sẽ cập nhật {{count}} hồ sơ bệnh nhân hiện có. Tiếp tục?",
    "confirmUpdateConfirm": "Cập nhật",
    "fields": {
      "patientId": "Mã bệnh nhân",
      "firstName": "Tên",
      "lastName": "Họ",
      "gender": "Giới tính",
      "dateOfBirth": "Ngày sinh",
      "phone": "Số điện thoại",
      "alternatePhone": "SĐT phụ",
      "email": "Email",
      "citizenId": "CCCD/CMND",
      "healthInsuranceNumber": "Số thẻ bảo hiểm y tế",
      "weightKg": "Cân nặng (kg)",
      "bloodType": "Nhóm máu",
      "occupation": "Nghề nghiệp",
      "street": "Địa chỉ",
      "ward": "Phường/xã",
      "wardCode": "Mã phường/xã",
      "province": "Tỉnh/thành",
      "provinceCode": "Mã tỉnh",
      "country": "Quốc gia",
      "clinicBranchCode": "Mã chi nhánh",
      "customerSourceCode": "Mã nguồn",
      "guardianName": "Người giám hộ",
      "guardianPhone": "SĐT giám hộ",
      "medicalHistory": "Tiền sử bệnh",
      "notes": "Ghi chú",
      "isForeigner": "Ngoại kiều",
      "isVietKieu": "Việt kiều",
      "residenceCountry": "Quốc gia sinh sống",
      "residenceRegion": "Bang / Tỉnh",
      "createdAt": "Ngày đăng ký",
      "createdByStaffCode": "Mã NV người tạo"
    },
    "rowErrors": {
      "PATIENT_ID_INVALID": "Mã bệnh nhân tối đa {{max}} ký tự.",
      "DUPLICATE_PATIENT_ID": "Mã bệnh nhân bị trùng trong file.",
      "FIRST_NAME_REQUIRED": "Thiếu tên.",
      "FIRST_NAME_TOO_LONG": "Tên không được vượt quá {{max}} ký tự.",
      "LAST_NAME_REQUIRED": "Thiếu họ.",
      "LAST_NAME_TOO_LONG": "Họ không được vượt quá {{max}} ký tự.",
      "GENDER_INVALID": "Giới tính phải là Nam / Nữ / Khác (hoặc male / female / other).",
      "DOB_REQUIRED": "Thiếu ngày sinh.",
      "DOB_INVALID": "Ngày sinh phải là YYYY-MM-DD hoặc DD/MM/YYYY và không ở tương lai.",
      "CREATED_AT_INVALID": "Ngày đăng ký phải là YYYY-MM-DD hoặc DD/MM/YYYY, có thể kèm giờ (HH:mm hoặc HH:mm:ss), và không ở tương lai.",
      "CREATED_AT_BEFORE_DOB": "Ngày đăng ký không được trước ngày sinh.",
      "PHONE_INVALID": "Số điện thoại không hợp lệ.",
      "ALTERNATE_PHONE_INVALID": "Số điện thoại phụ không hợp lệ.",
      "GUARDIAN_PHONE_INVALID": "Số điện thoại người giám hộ không hợp lệ.",
      "EMAIL_INVALID": "Email không hợp lệ.",
      "DUPLICATE_PHONE": "Số điện thoại bị trùng trong file.",
      "CLINIC_REQUIRED": "Thiếu mã chi nhánh.",
      "CLINIC_UNKNOWN": "Không tìm thấy mã chi nhánh {{clinicBranchCode}}.",
      "CLINIC_OUT_OF_SCOPE": "Mã chi nhánh {{clinicBranchCode}} nằm ngoài phạm vi phòng khám hiện tại.",
      "CLINIC_INACTIVE": "Mã chi nhánh {{clinicBranchCode}} đang ngừng hoạt động.",
      "PATIENT_ID_PURGED": "Mã {{patientId}} thuộc hồ sơ đã xóa vĩnh viễn.",
      "PATIENT_ID_ARCHIVED": "Mã {{patientId}} thuộc hồ sơ đang lưu trữ. Khôi phục trước khi cập nhật.",
      "PATIENT_PHONE_EXISTS": "Số điện thoại đã được dùng cho bệnh nhân khác.",
      "SOURCE_UNKNOWN": "Không tìm thấy mã nguồn {{customerSourceCode}}.",
      "SOURCE_INACTIVE": "Mã nguồn {{customerSourceCode}} đang ngừng dùng.",
      "IS_FOREIGNER_INVALID": "Ngoại kiều phải là Có/Không, true/false, hoặc 1/0.",
      "IS_VIET_KIEU_INVALID": "Việt kiều phải là Có/Không, true/false, hoặc 1/0.",
      "ORIGIN_CONFLICT": "Không thể vừa là Ngoại kiều vừa là Việt kiều.",
      "NOTES_TOO_LONG": "Ghi chú không được vượt quá {{max}} ký tự.",
      "HEALTH_INSURANCE_NUMBER_TOO_LONG": "Số thẻ bảo hiểm y tế không được vượt quá {{max}} ký tự.",
      "WEIGHT_INVALID": "Cân nặng phải từ 3 đến 150 kg, tối đa một chữ số thập phân.",
      "BLOOD_TYPE_INVALID": "Nhóm máu phải là A+, A-, B+, B-, AB+, AB-, O+ hoặc O-.",
      "CREATED_BY_STAFF_UNKNOWN": "Không tìm thấy mã nhân viên {{createdByStaffCode}}.",
      "CREATED_BY_STAFF_NO_USER": "Nhân viên {{createdByStaffCode}} chưa gắn tài khoản đăng nhập, không gán được người tạo."
    }
  },
  "empty": {
    "title": "Chưa có bệnh nhân",
    "description": "Thêm bệnh nhân đầu tiên để bắt đầu.",
    "noPatients": "Không tìm thấy bệnh nhân"
  },
  "tabs": {
    "overview": "Tổng quan",
    "appointments": "Lịch hẹn",
    "clinical": "Tình trạng răng",
    "treatments": "Kế hoạch",
    "treatmentProgress": "Tiến trình",
    "treatmentJournal": "Nhật ký điều trị",
    "payments": "Thanh toán",
    "documents": "Tài liệu & Hình ảnh",
    "communication": "Tin nhắn",
    "prescriptions": "Đơn thuốc",
    "labOrders": "Đơn lab",
    "messageDeliveries": "Lịch sử gửi tin",
    "contact": "Liên hệ"
  },
  "clinical": {
    "title": "Tình trạng răng",
    "odontogramTitle": "Sơ đồ răng",
    "toolsToggle": "Công cụ sơ đồ răng",
    "toothNumberOnly": "Răng {{number}}",
    "toothDisplayName": "{{type}} — {{arch}}",
    "toothQuadrants": {
      "1": "Hàm trên bên phải (BN)",
      "2": "Hàm trên bên trái (BN)",
      "3": "Hàm dưới bên trái (BN)",
      "4": "Hàm dưới bên phải (BN)",
      "5": "Hàm trên bên phải — răng sữa",
      "6": "Hàm trên bên trái — răng sữa",
      "7": "Hàm dưới bên trái — răng sữa",
      "8": "Hàm dưới bên phải — răng sữa"
    },
    "toothTypes": {
      "1": "Răng cửa giữa",
      "2": "Răng cửa bên",
      "3": "Răng nanh",
      "4": "Răng tiền hàm 1",
      "5": "Răng tiền hàm 2",
      "6": "Răng hàm 1",
      "7": "Răng hàm 2",
      "8": "Răng hàm 3"
    },
    "detail": {
      "emptyTitle": "Chưa chọn răng",
      "emptyHint": "Chọn một răng trên sơ đồ bên trái để xem lịch sử lâm sàng.",
      "multiSelected": "Đã chọn {{count}} răng",
      "multiSelectedHint": "Chẩn đoán hàng loạt hoặc bỏ chọn để xem chi tiết từng răng.",
      "historyTitle": "Lịch sử lâm sàng",
      "historyEmpty": "Chưa có ghi nhận lâm sàng hoặc điều trị cho răng này.",
      "loadingHistory": "Đang tải lịch sử điều trị…",
      "fdiLabel": "Số FDI {{number}}"
    },
    "timeline": {
      "condition": "Tình trạng",
      "treatment": "Điều trị",
      "dentist": "Bác sĩ",
      "done": "Hoàn thành",
      "pending": "Chờ thực hiện",
      "inProgress": "Đang thực hiện",
      "plannedReason": "Hạng mục trong kế hoạch điều trị — chưa thực hiện"
    },
    "dentition": "Loại răng",
    "dentitions": {
      "permanent": "Răng vĩnh viễn",
      "primary": "Răng sữa",
      "mixed": "Hỗn hợp"
    },
    "selectedTeeth": "Răng / mặt đã chọn",
    "noSelection": "Chưa chọn răng",
    "status": "Tình trạng",
    "notes": "Ghi chú",
    "save": "Lưu",
    "remove": "Xóa tình trạng",
    "createTreatmentPlan": "Tạo kế hoạch điều trị",
    "recordedTitle": "Răng đã ghi nhận",
    "recordedEmpty": "Chưa có tình trạng răng nào được ghi nhận",
    "tooth": "Răng",
    "surfacesColumn": "Mặt răng",
    "surfacesLabel": "Mặt răng (M/O/D/B/L)",
    "surfacesDisabledHint": "Tình trạng toàn răng (mất/mão/cầu/implant) không gắn theo mặt.",
    "archUpper": "Hàm trên",
    "archLower": "Hàm dưới",
    "archAria": "Sơ đồ răng FDI",
    "patientRight": "Phải (BN)",
    "patientLeft": "Trái (BN)",
    "clearSelection": "Bỏ chọn",
    "wholeTooth": "Cả răng",
    "dialog": {
      "title": "Chẩn đoán",
      "cancel": "Hủy",
      "multiTeeth": "{{count}} răng đã chọn",
      "openWithCount": "Chẩn đoán ({{count}})"
    },
    "quickSelect": {
      "all": "Cả miệng",
      "upper": "Hàm trên",
      "lower": "Hàm dưới",
      "patientRight": "Phải (BN)",
      "patientLeft": "Trái (BN)",
      "upperRight": "Trên phải",
      "upperLeft": "Trên trái",
      "lowerRight": "Dưới phải",
      "lowerLeft": "Dưới trái"
    },
    "permissionDenied": "Bạn không có quyền xem lâm sàng",
    "readOnly": "Bạn chỉ có quyền xem, không thể chỉnh sửa",
    "loadFailed": "Không tải được sơ đồ răng",
    "saveSuccess": "Đã lưu tình trạng răng",
    "saveFailed": "Không lưu được tình trạng răng",
    "removeSuccess": "Đã xóa tình trạng răng",
    "removeFailed": "Không xóa được tình trạng răng",
    "surfaces": {
      "M": "M (Mesial)",
      "O": "O (Occlusal)",
      "D": "D (Distal)",
      "B": "B (Buccal)",
      "L": "L (Lingual)"
    },
    "statuses": {
      "healthy": "Lành mạnh",
      "caries": "Sâu răng",
      "filled": "Đã trám",
      "missing": "Mất răng",
      "crown": "Mão răng",
      "root_canal": "Điều trị tủy",
      "bridge": "Cầu răng",
      "implant": "Implant",
      "mobility": "Lung lay",
      "other": "Khác"
    }
  },
  "sections": {
    "personalInfo": "Thông tin cá nhân",
    "contactInfo": "Thông tin liên hệ",
    "guardianInfo": "Người giám hộ",
    "medicalInfo": "Thông tin y tế",
    "clinicInfo": "Thông tin phòng khám",
    "relationships": "Mối quan hệ liên kết"
  },
  "fields": {
    "firstName": "Tên",
    "lastName": "Họ",
    "fullName": "Họ và tên",
    "gender": "Giới tính",
    "dateOfBirth": "Ngày sinh",
    "age": "Tuổi",
    "ageYears": "tuổi",
    "ageYearsParen": "({{age}} tuổi)",
    "occupation": "Nghề nghiệp",
    "citizenId": "Số CCCD",
    "healthInsuranceNumber": "Số thẻ bảo hiểm y tế",
    "weightKg": "Cân nặng",
    "weightKgValue": "{{value}} kg",
    "bloodType": "Nhóm máu",
    "passportId": "Số hộ chiếu",
    "isForeigner": "Ngoại kiều",
    "isVietKieu": "Việt kiều",
    "conversionStatus": "Trạng thái chuyển đổi",
    "convertedAt": "Chuyển đổi lần đầu",
    "email": "Email",
    "phone": "Số điện thoại liên hệ",
    "alternatePhone": "Số điện thoại phụ",
    "addAlternatePhone": "Thêm",
    "hideAlternatePhone": "Thu gọn",
    "contactAddress": "Địa chỉ liên hệ",
    "street": "Địa chỉ (Số nhà, Tên đường)",
    "country": "Quốc gia",
    "residenceCountry": "Quốc gia sinh sống",
    "residenceRegion": "Bang / Tỉnh",
    "stateCity": "Bang / Thành phố",
    "province": "Tỉnh/Thành phố",
    "ward": "Phường/Xã",
    "guardianName": "Tên người giám hộ",
    "guardianPhone": "SĐT người giám hộ",
    "guardianPhoneParen": "(SĐT: {{phone}})",
    "medicalHistory": "Tiền sử bệnh",
    "notes": "Ghi chú",
    "medicalHistoryPlaceholder": "Chọn hoặc gõ rồi nhấn Enter để thêm...",
    "medicalHistoryHelper": "Chọn từ danh sách có sẵn hoặc tự gõ rồi nhấn Enter để nhập mới",
    "medicalHistoryHighRisk": "Bệnh lý cần lưu ý khi điều trị",
    "medicalHistoryOtherSelect": "Bệnh lý khác",
    "patientCode": "Mã bệnh nhân",
    "patientCodeHelper": "Để trống để hệ thống tự tạo mã. Chỉ nhập khi cần dùng mã có sẵn.",
    "patientCodeLocked": "Mã bệnh nhân không thể thay đổi sau khi tạo",
    "removeMedicalHistoryItem": "Xóa {{name}}",
    "patientSearchPlaceholder": "Tìm tên / SĐT / mã BN",
    "searchTypeMore": "Nhập ít nhất 2 ký tự",
    "searchNoResults": "Không tìm thấy bệnh nhân",
    "selectPatient": "Chọn bệnh nhân",
    "clinic": "Phòng khám",
    "primaryClinic": "Phòng khám chính",
    "registrationDate": "Ngày đăng ký",
    "referredBy": "Người giới thiệu",
    "customerSource": "Nguồn khách hàng",
    "customerGroup": "Phân nhóm khách hàng",
    "relationshipType": "Mối quan hệ",
    "socialAccounts": "Mạng xã hội",
    "socialPlatform": "Nền tảng",
    "socialAccount": "Tài khoản",
    "address": "Địa chỉ",
    "ageGroup": "Nhóm tuổi"
  },
  "placeholders": {
    "lastName": "Nhập họ và chữ lót",
    "firstName": "Nhập tên",
    "gender": "Chọn giới tính",
    "ageGroup": "Chọn nhóm tuổi",
    "dateOfBirth": "DD/MM/YYYY",
    "citizenId": "001234567890",
    "healthInsuranceNumber": "DN4790123456789",
    "weightKg": "65",
    "bloodType": "Chọn nhóm máu",
    "passportId": "A12345678",
    "occupation": "Chọn nghề nghiệp",
    "email": "email@example.com",
    "phone": "Ví dụ: 0901234567",
    "alternatePhone": "Ví dụ: 0901234567",
    "country": "Chọn quốc gia",
    "residenceCountry": "Chọn quốc gia",
    "residenceRegion": "Chọn bang / tỉnh",
    "stateCity": "Chọn bang / thành phố",
    "street": "Số nhà, tên đường",
    "province": "Chọn tỉnh/thành phố",
    "ward": "Chọn phường/xã",
    "guardianName": "Nhập tên người giám hộ",
    "patientId": "Để trống hệ thống tự sinh",
    "guardianPhone": "Ví dụ: 0901234567",
    "notes": "Nhập ghi chú",
    "clinic": "Chọn phòng khám",
    "customerSource": "Chọn nguồn khách hàng",
    "customerGroup": "Chọn phân nhóm khách hàng",
    "relationshipType": "Chọn mối quan hệ",
    "socialAccount": "Số, username hoặc link"
  },
  "gender": {
    "male": "Nam",
    "female": "Nữ",
    "other": "Khác",
    "maleShort": "Nam",
    "femaleShort": "Nữ",
    "otherShort": "Khác"
  },
  "ageGroup": {
    "all": "Tất cả",
    "below18": "Dưới 18",
    "18to30": "18-30",
    "31to45": "31-45",
    "46to60": "46-60",
    "above60": "Trên 60"
  },
  "options": {
    "unknown": "Không rõ",
    "all": "Tất cả"
  },
  "referredBy": {
    "patient": "Bệnh nhân",
    "staff": "Nhân viên",
    "patientSuffix": "{{name}} (Bệnh nhân)",
    "staffSuffix": "{{name}} (Nhân viên)",
    "externalSuffix": "{{name}} (Đối tác)",
    "external": "Đối tác"
  },
  "search": {
    "patient": "Bệnh nhân",
    "patientRequired": "Tìm kiếm bệnh nhân",
    "byNamePhone": "Nhập tên hoặc số điện thoại..."
  },
  "relationshipTypes": {
    "parent": "Cha/Mẹ",
    "spouse": "Vợ/Chồng",
    "child": "Con cái",
    "sibling": "Anh/Chị/Em",
    "relative": "Cô/Dì/Chú/Bác",
    "nephewNiece": "Cháu",
    "friend": "Bạn bè",
    "colleague": "Đồng nghiệp",
    "other": "Khác"
  },
  "customerSourceCatalog": {
    "pages": {
      "title": "Nguồn khách hàng",
      "permissionDenied": "Bạn không có quyền xem danh mục nguồn khách hàng."
    },
    "actions": {
      "add": "Thêm nguồn",
      "deactivate": "Ngừng dùng",
      "deactivating": "Đang ngừng dùng...",
      "reactivate": "Bật lại",
      "reactivating": "Đang bật lại...",
      "history": "Lịch sử"
    },
    "history": {
      "title": "Lịch sử nguồn khách hàng",
      "empty": "Chưa có lịch sử thay đổi cho nguồn này."
    },
    "search": {
      "placeholder": "Tìm nguồn khách hàng..."
    },
    "fields": {
      "name": "Tên",
      "sortOrder": "Thứ tự",
      "status": "Trạng thái",
      "type": "Kiểu"
    },
    "type": {
      "system": "Hệ thống",
      "custom": "Tùy chỉnh"
    },
    "form": {
      "name": "Tên nguồn khách hàng"
    },
    "placeholders": {
      "name": "Ví dụ: TikTok, Đối tác phòng khám",
      "sortOrder": "0"
    },
    "status": {
      "active": "Đang dùng",
      "inactive": "Ngừng dùng"
    },
    "dialogs": {
      "addTitle": "Thêm nguồn khách hàng",
      "editTitle": "Sửa nguồn khách hàng",
      "confirmDeactivate": "Ngừng dùng nguồn \"{{name}}\"?"
    },
    "table": {
      "code": "Mã",
      "createdAt": "Ngày tạo",
      "updatedAt": "Cập nhật",
      "createdBy": "Người tạo",
      "updatedBy": "Người cập nhật",
      "empty": "Chưa có nguồn khách hàng",
      "noFound": "Không tìm thấy nguồn phù hợp"
    },
    "validation": {
      "nameRequired": "Vui lòng nhập tên nguồn",
      "sortOrderInvalid": "Thứ tự phải là số nguyên",
      "sortOrderMin": "Thứ tự không được âm"
    },
    "toasts": {
      "created": "Đã thêm nguồn khách hàng",
      "updated": "Đã cập nhật nguồn khách hàng",
      "deactivated": "Đã ngừng dùng nguồn khách hàng",
      "reactivated": "Đã bật lại nguồn khách hàng",
      "saveFailed": "Không lưu được nguồn khách hàng",
      "deactivateFailed": "Không ngừng dùng được nguồn khách hàng",
      "reactivateFailed": "Không bật lại được nguồn khách hàng",
      "loadFailed": "Không tải được danh mục nguồn khách hàng"
    }
  },
  "medicalHistoryPresets": {
    "diabetes": "Tiểu đường",
    "hypertension": "Huyết áp cao",
    "heart": "Tim mạch",
    "drugAllergy": "Dị ứng thuốc tê",
    "antibioticAllergy": "Dị ứng kháng sinh",
    "pregnant": "Đang mang thai",
    "bleeding": "Chảy máu lâu đông",
    "stomach": "Dạ dày/Tá tràng",
    "asthma": "Hen suyễn"
  },
  "customerGroup": {
    "implant": "Khách hàng Implant",
    "ceramic": "Khách hàng sứ",
    "ortho": "Khách hàng chỉnh nha",
    "pediatric": "Khách hàng trẻ em",
    "general": "Khách hàng tổng quát"
  },
  "conversionStatus": {
    "converted": "Đã chuyển đổi",
    "notConverted": "Chưa chuyển đổi",
    "rejected": "Từ chối"
  },
  "filtersConversion": {
    "select": "Chọn chuyển đổi",
    "all": "Tất cả chuyển đổi"
  },
  "filtersCustomerSource": {
    "select": "Chọn nguồn khách hàng",
    "all": "Tất cả nguồn khách hàng"
  },
  "filtersCustomerGroup": {
    "label": "Nhóm khách hàng",
    "select": "Chọn nhóm khách hàng",
    "all": "Tất cả nhóm khách hàng"
  },
  "filtersMedicalHistory": {
    "select": "Chọn tiền sử bệnh",
    "all": "Tất cả tiền sử bệnh"
  },
  "filtersOccupation": {
    "select": "Chọn nghề nghiệp",
    "all": "Tất cả nghề nghiệp"
  },
  "table": {
    "id": "Mã",
    "name": "Họ tên",
    "patientFullName": "Họ & tên bệnh nhân",
    "patient": "Bệnh nhân",
    "phone": "Số điện thoại",
    "email": "Email",
    "contact": "Liên hệ",
    "customerSource": "Nguồn khách",
    "customerGroup": "Nhóm khách",
    "occupation": "Nghề nghiệp",
    "address": "Địa chỉ",
    "dateOfBirth": "Ngày sinh",
    "registrationDate": "Ngày đăng ký",
    "ageGender": "Tuổi/Giới tính",
    "lastVisit": "Khám gần nhất",
    "createdAt": "Ngày tạo",
    "createdBy": "Người tạo",
    "clinic": "Phòng khám",
    "conversion": "Chuyển đổi",
    "conversionStatus": "Trạng thái chuyển đổi",
    "actions": "Thao tác"
  },
  "menu": {
    "viewDetails": "Xem chi tiết",
    "editPatient": "Sửa bệnh nhân",
    "deletePatient": "Lưu trữ bệnh nhân",
    "restorePatient": "Khôi phục bệnh nhân",
    "purgePatient": "Xóa vĩnh viễn",
    "edit": "Sửa",
    "addAppointment": "Thêm lịch hẹn",
    "createTreatmentPlan": "Tạo kế hoạch điều trị",
    "delete": "Lưu trữ",
    "restore": "Khôi phục"
  },
  "deleteDialog": {
    "title": "Lưu trữ hồ sơ bệnh nhân",
    "confirm": "Lưu trữ hồ sơ {{name}}? Bệnh nhân sẽ ẩn khỏi danh sách đang dùng. Kế hoạch, thanh toán và lịch sử vẫn được giữ. Có thể khôi phục sau.",
    "thisPatient": "bệnh nhân này",
    "confirmAction": "Lưu trữ"
  },
  "archive": {
    "banner": "Hồ sơ này đã được lưu trữ. Không thể tạo lịch hẹn, kế hoạch hay thanh toán mới cho đến khi khôi phục.",
    "badge": "Đã lưu trữ",
    "restore": "Khôi phục hồ sơ",
    "purge": "Xóa vĩnh viễn",
    "purgedBanner": "Hồ sơ đã xóa vĩnh viễn (anonymize). Không thể khôi phục."
  },
  "purgeDialog": {
    "title": "Xóa vĩnh viễn hồ sơ",
    "confirm": "Xóa vĩnh viễn {{name}}? Dữ liệu cá nhân sẽ được ẩn danh; kế hoạch/thanh toán vẫn giữ. Không thể khôi phục. Nhập mã {{code}} để xác nhận.",
    "codeLabel": "Mã bệnh nhân",
    "confirmAction": "Xóa vĩnh viễn"
  },
  "filtersArchived": {
    "label": "Trạng thái hồ sơ",
    "select": "Chọn trạng thái hồ sơ",
    "active": "Đang dùng",
    "archived": "Đã lưu trữ"
  },
  "pagination": {
    "rowsPerPage": "Số dòng mỗi trang:",
    "displayedRows": "{{from}}–{{to}} trong {{count}}",
    "moreThan": "hơn {{to}}"
  },
  "validation": {
    "firstNameRequired": "Vui lòng nhập tên",
    "lastNameRequired": "Vui lòng nhập họ",
    "nameRequired": "Vui lòng nhập họ tên",
    "genderRequired": "Vui lòng chọn giới tính",
    "dobRequired": "Vui lòng chọn ngày sinh",
    "clinicRequired": "Vui lòng chọn phòng khám",
    "patientIdMax": "Mã bệnh nhân tối đa {{max}} ký tự",
    "notesMax": "Ghi chú tối đa {{max}} ký tự",
    "healthInsuranceNumberMax": "Số thẻ bảo hiểm y tế tối đa {{max}} ký tự",
    "weightKgMax": "Cân nặng từ {{min}} đến {{max}} kg, tối đa một chữ số thập phân",
    "socialAccountMax": "Tài khoản tối đa {{max}} ký tự",
    "socialPlatformDuplicate": "Mỗi nền tảng chỉ lưu một lần",
    "countryRequired": "Vui lòng nhập quốc gia cư trú",
    "residenceCountryRequired": "Vui lòng chọn quốc gia sinh sống",
    "originExclusive": "Không thể vừa là Ngoại kiều vừa là Việt kiều"
  },
  "toasts": {
    "loadFailed": "Không thể tải danh sách bệnh nhân",
    "loadFailedDetail": "Không thể tải danh sách bệnh nhân: {{message}}",
    "loadFailedRetry": "Không thể tải danh sách bệnh nhân. Vui lòng thử lại.",
    "loadDataFailed": "Không thể tải dữ liệu",
    "loadDataFailedRetry": "Không thể tải dữ liệu. Vui lòng thử lại.",
    "loadPatientDataFailed": "Không thể tải dữ liệu bệnh nhân",
    "loadPatientDataFailedRetry": "Không thể tải dữ liệu bệnh nhân. Vui lòng thử lại.",
    "authTokenNotFound": "Không tìm thấy mã xác thực",
    "deleteSuccess": "Lưu trữ hồ sơ thành công",
    "deleteSuccessNamed": "Đã lưu trữ hồ sơ {{name}}",
    "deleteFailed": "Không thể lưu trữ hồ sơ bệnh nhân",
    "restoreSuccess": "Khôi phục hồ sơ thành công",
    "restoreSuccessNamed": "Đã khôi phục hồ sơ {{name}}",
    "restoreFailed": "Không thể khôi phục hồ sơ bệnh nhân",
    "purgeSuccess": "Đã xóa vĩnh viễn hồ sơ",
    "purgeSuccessNamed": "Đã xóa vĩnh viễn hồ sơ {{name}}",
    "purgeFailed": "Không thể xóa vĩnh viễn hồ sơ bệnh nhân",
    "addSuccess": "Thêm bệnh nhân thành công!",
    "addFailed": "Không thể thêm bệnh nhân",
    "addFailedRetry": "Không thể thêm bệnh nhân. Vui lòng thử lại.",
    "updateSuccess": "Cập nhật bệnh nhân thành công!",
    "updateFailed": "Không thể cập nhật bệnh nhân",
    "updateFailedRetry": "Không thể cập nhật bệnh nhân. Vui lòng thử lại.",
    "selectClinic": "Vui lòng chọn phòng khám",
    "downloading": "Đang tải xuống {{fileName}}",
    "downloadSuccess": "Đã tải xuống {{fileName}} thành công",
    "downloadFailed": "Tải xuống thất bại",
    "selectPatient": "Vui lòng chọn một bệnh nhân",
    "addRelationshipSuccess": "Thêm mối quan hệ thành công",
    "addRelationshipFailed": "Không thể thêm mối quan hệ",
    "deleteRelationshipSuccess": "Xóa mối quan hệ thành công",
    "deleteRelationshipFailed": "Không thể xóa mối quan hệ",
    "exported": "Đã xuất danh sách bệnh nhân",
    "exportFailed": "Không xuất được danh sách bệnh nhân",
    "imported": "Đã nhập danh sách bệnh nhân",
    "importFailed": "Không nhập được danh sách bệnh nhân",
    "templateFailed": "Không tải được file mẫu"
  },
  "fallbacks": {
    "notSpecified": "Chưa xác định",
    "notProvided": "Chưa cung cấp",
    "notAssigned": "Chưa gán",
    "notAvailable": "N/A"
  },
  "medicalHistory": {
    "none": "Không có tiền sử bệnh",
    "noSignificant": "Không có tiền sử bệnh đáng chú ý",
    "diabetic": "Tiểu đường",
    "hypertension": "Huyết áp cao",
    "pregnant": "Đang mang thai",
    "allergies": "Dị ứng: {{list}}",
    "currentMedications": "Thuốc đang dùng: {{list}}",
    "pastIllnesses": "Bệnh đã mắc: {{list}}",
    "surgeries": "Phẫu thuật: {{list}}"
  },
  "socialPlatforms": {
    "zalo": "Zalo",
    "facebook": "Facebook",
    "instagram": "Instagram",
    "threads": "Threads",
    "tiktok": "TikTok",
    "whatsapp": "WhatsApp",
    "telegram": "Telegram",
    "x": "X"
  },
  "socialAccounts": {
    "add": "Thêm"
  },
  "relationships": {
    "add": "Thêm mối quan hệ",
    "empty": "Chưa có mối quan hệ liên kết nào được thiết lập.",
    "deleteTooltip": "Xóa mối quan hệ",
    "deleteConfirm": "Bạn có chắc chắn muốn xóa mối quan hệ này không?",
    "dialogTitle": "Thêm mối quan hệ liên kết",
    "searchLabel": "Tìm kiếm bệnh nhân liên kết",
    "searchPlaceholder": "Nhập tên hoặc số điện thoại...",
    "searchHelper": "Gõ ít nhất 2 ký tự để tìm kiếm bệnh nhân",
    "typeLabel": "Mối quan hệ",
    "save": "Lưu lại",
    "phoneShort": "SĐT: {{phone}}"
  },
  "appointments": {
    "title": "Lịch hẹn",
    "new": "Lịch hẹn mới",
    "empty": "Không có lịch hẹn nào cho bệnh nhân này.",
    "emptyUpcoming": "Không có lịch hẹn sắp tới.",
    "emptyPast": "Không có lịch hẹn đã qua.",
    "emptyFiltered": "Không có lịch hẹn phù hợp bộ lọc.",
    "code": "Mã lịch hẹn",
    "date": "Ngày hẹn",
    "time": "Giờ hẹn",
    "type": "Loại lịch hẹn",
    "chair": "Ghế nha",
    "dentist": "Bác sĩ",
    "dentistName": "BS. {{name}}",
    "status": "Trạng thái",
    "notes": "Ghi chú",
    "actions": "Thao tác",
    "itemActions": "Thao tác lịch hẹn",
    "filterLabel": "Lọc theo thời gian",
    "filterAll": "Tất cả",
    "filterUpcoming": "Sắp tới",
    "filterPast": "Đã qua",
    "viewLabel": "Chế độ xem",
    "viewTable": "Bảng",
    "viewTimeline": "Timeline",
    "sectionUpcoming": "Lịch hẹn sắp tới",
    "sectionPast": "Lịch hẹn đã qua"
  },
  "treatments": {
    "title": "Điều trị",
    "create": "Tạo kế hoạch",
    "empty": "Không có kế hoạch điều trị nào cho bệnh nhân này.",
    "selectPlan": "Chọn một kế hoạch để xem chi tiết.",
    "selectPlanPlaceholder": "Chọn kế hoạch",
    "plan": "Kế hoạch",
    "planCode": "Mã kế hoạch",
    "status": "Trạng thái",
    "services": "Dịch vụ",
    "doctor": "Bác sĩ phụ trách",
    "gross": "Tổng tiền điều trị",
    "discount": "Giảm giá",
    "payable": "Phải thanh toán",
    "quoted": "Dự kiến thu",
    "contracted": "Đã xác nhận / Phải thanh toán",
    "unallocatedPlanAdvance": "Tạm ứng chưa gán",
    "total": "Phải thanh toán",
    "paid": "Đã thu (dịch vụ)",
    "balance": "Còn lại",
    "payment": "Thanh toán",
    "paymentSummary": "Tóm tắt thanh toán",
    "viewPlan": "Chi tiết kế hoạch",
    "dentistName": "BS. {{name}}",
    "planSection": "Dịch vụ điều trị",
    "progressSection": "Tiến trình điều trị",
    "progressVisitCount": "({{count}})",
    "emptyProgress": "Chưa có buổi điều trị cho kế hoạch này.",
    "viewModeLabel": "Chế độ xem tiến trình",
    "viewTimeline": "Timeline",
    "viewList": "Danh sách",
    "addService": "Thêm dịch vụ",
    "editPlan": "Chỉnh sửa kế hoạch",
    "deletePlan": "Xóa kế hoạch",
    "actions": "Thao tác"
  },
  "payments": {
    "title": "Lịch sử thanh toán",
    "subtitle": "Thanh toán của {{name}}",
    "count": "{{count}} phiếu thu",
    "record": "Ghi nhận thanh toán",
    "debtSectionTitle": "Công nợ kế hoạch",
    "debtSectionHint": "Đã thanh toán là phần nợ đã gạch trên kế hoạch (có thể gồm voucher quyết toán). Khác với thực thu trên từng phiếu.",
    "historyTitle": "Lịch sử phiếu thu",
    "summaryGross": "Tổng tiền điều trị",
    "summaryDiscount": "Giảm giá",
    "summaryPayable": "Phải thanh toán",
    "totalPlanCost": "Phải thanh toán",
    "totalPaid": "Đã thanh toán",
    "outstandingBalance": "Còn lại",
    "summaryPaid": "Đã thanh toán",
    "summaryBalance": "Còn lại",
    "emptyTitle": "Chưa có phiếu thu",
    "emptyDescription": "Chưa có phiếu thu nào được ghi nhận cho bệnh nhân này.",
    "recordFirst": "Ghi nhận thanh toán đầu tiên",
    "paymentCode": "Mã thanh toán",
    "receiptStatus": "Trạng thái",
    "purpose": "Loại phiếu",
    "date": "Ngày thanh toán",
    "createdAt": "Ngày tạo phiếu",
    "treatmentPlan": "Kế hoạch",
    "method": "Phương thức",
    "receivedBy": "Người thu",
    "recordedAmount": "Ghi nhận",
    "amountColumn": "Số tiền thực thu",
    "amount": "Ghi nhận",
    "netCollected": "Số tiền thực thu",
    "planAmount": "Thanh toán tạm tính",
    "voucherApplied": "Voucher {{code}} (−{{discount}})",
    "netCollectedCaption": {
      "voucher": "Voucher",
      "mixed": "Hỗn hợp",
      "withNet": "Thực thu {{amount}}",
      "withRecorded": "Ghi nhận {{amount}}",
      "breakdownTitle": "Chi tiết phiếu thu",
      "breakdownAria": "Thực thu {{amount}} ({{source}}). Bấm để xem chi tiết."
    },
    "actions": "Thao tác",
    "viewDetails": "Xem chi tiết thanh toán",
    "editPayment": "Sửa thanh toán"
  },
  "planAdvance": {
    "title": "Tạm ứng điều trị",
    "subtitle": "Tiền park theo kế hoạch, chưa gạch dịch vụ. Không dùng voucher.",
    "balanceLabel": "Tạm ứng chưa gán",
    "totalHeadroom": "Còn được tạm ứng (tất cả KH)",
    "availablePark": "Tổng chưa gán",
    "headroom": "Còn được tạm ứng",
    "byPlan": "Theo kế hoạch",
    "noPlans": "Chưa có kế hoạch điều trị phù hợp.",
    "viewHistory": "Xem phiếu tạm ứng",
    "historyTitle": "Phiếu tạm ứng",
    "historyTitleWithName": "Phiếu tạm ứng — {{name}}",
    "historyEmpty": "Chưa có phiếu tạm ứng hoặc hoàn tạm ứng."
  },
  "wallet": {
    "title": "Tài khoản nạp trước",
    "subtitle": "Tiền gốc có thể hoàn; tiền thưởng dùng trước khi thanh toán",
    "topUp": "Nạp tiền",
    "refund": "Hoàn/rút",
    "availableBalance": "Số dư khả dụng",
    "principal": "Gốc (có thể hoàn)",
    "bonus": "Tiền thưởng",
    "principalShort": "Gốc",
    "bonusShort": "Thưởng",
    "principalHint": "Có thể hoàn",
    "bonusHint": "Ưu tiên khi trừ",
    "totalTopUp": "Đã nạp",
    "totalBonusReceived": "Khuyến mãi",
    "totalSpent": "Đã chi",
    "totalRefund": "Đã hoàn",
    "lifetimeSection": "Lũy kế",
    "lifetimeSummary": "Nạp {{topup}} · Chi {{spent}} · Hoàn {{refund}}",
    "balanceBreakdown": "(Gốc {{principal}} · Thưởng {{bonus}})",
    "balanceLabel": "Số dư TK nạp trước",
    "viewHistory": "Xem lịch sử giao dịch",
    "historyTitle": "Lịch sử TK nạp trước",
    "historyTitleWithName": "Lịch sử TK nạp trước — {{name}}",
    "emptyTitle": "Chưa có giao dịch TK nạp trước",
    "firstTopUp": "Nạp tiền lần đầu",
    "loadFailed": "Không tải được thông tin TK nạp trước",
    "permissionDenied": "Bạn không có quyền xem tài khoản nạp trước."
  },
  "documents": {
    "title": "Tài liệu & Hình ảnh",
    "emptyTitle": "Chưa có tài liệu",
    "emptyDescription": "Bệnh nhân này chưa có tài liệu nào. Tải lên tài liệu đầu tiên để bắt đầu.",
    "upload": "Tải lên tài liệu",
    "uploadFirst": "Tải lên tài liệu đầu tiên",
    "supportedFormats": "Định dạng hỗ trợ: PDF, JPG, JPEG, PNG, DICOM",
    "confirmDeleteTitle": "Xóa tài liệu?",
    "confirmDelete": "Tài liệu đã chọn sẽ bị gỡ khỏi hồ sơ bệnh nhân và không còn xem lại được.",
    "category": "Loại",
    "description": "Mô tả (không bắt buộc)",
    "treatmentPhase": "Giai đoạn điều trị",
    "categories": {
      "image": "Hình ảnh",
      "document": "Tài liệu"
    },
    "treatmentPhases": {
      "before": "Trước điều trị",
      "during": "Trong điều trị",
      "after": "Sau điều trị",
      "other": "Khác"
    }
  },
  "messaging": {
    "noPermission": "Bạn không có quyền xem tin nhắn của bệnh nhân này.",
    "emptyTitle": "Chưa gắn hội thoại",
    "emptyDescription": "Hội thoại Facebook, Instagram hoặc Zalo gắn với bệnh nhân này sẽ hiện ở đây. Gắn hội thoại từ hộp thư hoặc tìm theo tên / số điện thoại.",
    "link": "Gắn hội thoại",
    "linkTitle": "Gắn hội thoại với bệnh nhân",
    "linkSearch": "Tìm theo tên hoặc số điện thoại…",
    "linkEmpty": "Không tìm thấy hội thoại chưa gắn.",
    "linkHint": "Chỉ hiện hội thoại chưa gắn Lead hoặc bệnh nhân.",
    "linkAction": "Gắn",
    "composerReadOnly": "Hồ sơ đã lưu trữ — chỉ xem tin nhắn.",
    "pick": "Chọn hội thoại phía trên để xem tin nhắn."
  },
  "messageDeliveries": {
    "sentAt": "Thời gian",
    "channel": "Kênh",
    "content": "Nội dung",
    "recipient": "Người nhận",
    "source": "Nguồn",
    "status": "Trạng thái",
    "empty": "Chưa có tin đã gửi cho bệnh nhân này.",
    "loadFailed": "Không tải được lịch sử gửi tin.",
    "channels": {
      "sms": "SMS",
      "zns": "ZNS",
      "email": "Email"
    },
    "sources": {
      "automation": "Tự động",
      "manual": "Thủ công",
      "reminder": "Nhắc",
      "test": "Thử",
      "auth": "Hệ thống"
    },
    "statuses": {
      "pending": "Đang gửi",
      "sent": "Đã gửi",
      "delivered": "Đã nhận",
      "failed": "Lỗi"
    }
  },
  "communication": {
    "title": "Lịch sử liên lạc",
    "send": "Gửi tin nhắn",
    "emptyTitle": "Chưa có lịch sử liên lạc",
    "emptyDescription": "Gửi nhắc lịch hẹn, theo dõi điều trị hoặc tin nhắn chung cho bệnh nhân.",
    "sendFirst": "Gửi tin nhắn đầu tiên",
    "dateTime": "Ngày & Giờ",
    "channel": "Kênh",
    "message": "Tin nhắn",
    "status": "Trạng thái",
    "response": "Phản hồi",
    "noResponse": "Chưa có phản hồi"
  },
  "prescriptions": {
    "title": "Đơn thuốc",
    "create": "Tạo đơn thuốc",
    "emptyTitle": "Chưa có đơn thuốc",
    "emptyDescription": "Bệnh nhân này chưa được kê đơn thuốc nào. Tạo đơn thuốc đầu tiên để bắt đầu.",
    "createFirst": "Tạo đơn thuốc đầu tiên",
    "number": "Số đơn",
    "date": "Ngày",
    "doctor": "Bác sĩ",
    "diagnosis": "Chẩn đoán",
    "medications": "Thuốc",
    "status": "Trạng thái",
    "actions": "Thao tác",
    "doctorPrefix": "BS. {{name}}",
    "unknownDoctor": "Không rõ",
    "noDiagnosis": "Chưa có chẩn đoán",
    "medicationCount": "{{count}} loại thuốc",
    "viewTooltip": "Xem chi tiết",
    "editTooltip": "Sửa đơn thuốc"
  },
  "labOrders": {
    "title": "Đơn lab",
    "create": "Tạo đơn lab",
    "loadFailed": "Không tải được đơn lab",
    "permissionDenied": "Bạn không có quyền xem đơn lab của bệnh nhân này.",
    "empty": "Chưa có đơn lab cho bệnh nhân này.",
    "orderCode": "Mã đơn",
    "partner": "Xưởng",
    "dentist": "Bác sĩ",
    "sentBy": "Người gửi",
    "dueDate": "Hạn trả",
    "status": "Trạng thái",
    "actions": "Thao tác"
  },
  "treatmentSessions": {
    "title": "Buổi điều trị",
    "create": "Tạo buổi điều trị",
    "recordVisit": "Ghi nhận buổi điều trị",
    "addVisit": "Thêm buổi",
    "addVisitDialogTitle": "Thêm công tác điều trị",
    "visitNo": "Lần",
    "clinicalContentPlaceholder": "Nội dung dịch vụ",
    "notesPlaceholder": "Ghi chú",
    "linkServicesPlaceholder": "Gắn dịch vụ",
    "discardDraft": "Bỏ dòng chưa lưu",
    "editVisit": "Sửa buổi",
    "doneEditing": "Xong",
    "openModule": "Mở nhật ký buổi điều trị",
    "loadFailed": "Không tải được buổi điều trị",
    "loadPlansFailed": "Không tải được kế hoạch điều trị",
    "permissionDenied": "Bạn không có quyền xem buổi điều trị của bệnh nhân này.",
    "empty": "Chưa có buổi điều trị cho bệnh nhân này. Ghi nhận từ kế hoạch điều trị.",
    "noPlanToRecord": "Bệnh nhân chưa có kế hoạch — tạo kế hoạch trước.",
    "pickPlanTitle": "Chọn kế hoạch để ghi nhận buổi",
    "pickPlanLabel": "Kế hoạch điều trị",
    "continueToRecord": "Tiếp tục",
    "sessionTitle": "Tiêu đề",
    "performed": "Ngày thực hiện",
    "dentist": "Bác sĩ",
    "planCode": "Mã kế hoạch",
    "service": "Dịch vụ",
    "teeth": "Răng",
    "actions": "Thao tác",
    "view": "Xem"
  },
  "activity": {
    "title": "Lịch sử hoạt động",
    "empty": "Chưa có hoạt động nào liên quan đến bệnh nhân này."
  },
  "rail": {
    "collapse": "Ẩn lịch sử hoạt động",
    "expand": "Lịch sử hoạt động"
  },
  "chatPanel": {
    "collapse": "Ẩn tin nhắn",
    "expand": "Tin nhắn"
  },
  "viewDoc": {
    "categoryLabel": "Loại: {{category}}",
    "phaseLabel": "Giai đoạn: {{phase}}",
    "noDescription": "Không có mô tả",
    "uploadedInfo": "{{user}} · {{date}}",
    "unknownUser": "Người dùng không xác định",
    "imagePreviewNote": "Bản xem trước hình ảnh sẽ được tích hợp tại đây trong môi trường production.",
    "pdfPreviewNote": "Trình xem PDF sẽ được tích hợp tại đây trong môi trường production.",
    "cannotPreview": "Không thể xem trước loại tệp này.",
    "downloadImage": "Tải xuống hình ảnh",
    "downloadPdf": "Tải xuống PDF",
    "downloadFile": "Tải xuống tệp"
  }
}
